import { Title, Body } from "@vds/typography";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { Tabs, Tab } from "@vds/tabs";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import AssetMapView from "./AssetMapView";
import AssetAlertView from "./AssetAlertView";
import AssetDataView from "./AssetDataView";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { fetchRequest, deleteRequest, fetchLocationAlertsRequest } from "../../../store/actions/asset";
import { fetchRequest as fetchDeviceProfilesRequest } from "../../../store/actions/deviceProfile";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import CreateDeviceProfile from "../../DeviceProfile/CreateDeviceProfile";
import { Button } from "@vds/buttons";
import { Dropdown } from "antd";
import {
  fetchDeviceNamesRequest,
  fetchDeviceProfilesRequest as fetchSingleAssetDeviceProfilesRequest,
  fetchDeviceTypesRequest,
  fetchLocationsRequest,
  updateUI,
} from "../../../store/actions/asset";
import { fetchalllocationRequest } from "../../../store/actions/deviceProfile";
import getSingleAsset from "../common/utils/getSingleAsset";
import FormAsset from "../form/index";
import DeleteAssetModal from "../DeleteAssetModel";
import ToastNotification from "../../../global/components/ToastNotification";
import { fetchRSSIHistoryRequest } from "../../../store/actions/deviceShipmentsDashboard";
import { isMoreThan7Days } from "../../../global/utility/GmtToLocal";
import { mapDataTabIndex } from "../../../store/actions/singleAsset";
import { isValidSafeUUIDv4 } from "../../../global/utility/Utils";
import DOMPurify from "dompurify";

function ViewAsset() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    asset,
    deviceData,
    address,
    isLoading,
    isFloorView,
    mapDataIndex,
    isDeviceProfileUpdated,
    allAssetsListData,
    dynamicMetricValues
  } = useSelector((state) => ({
    asset:
      Array.isArray(state?.asset?.data?.assetList) &&
      state?.asset?.data?.assetList.length > 0
        ? state?.asset?.data?.assetList[0]
        : {},
    deviceData: state?.asset?.data?.deviceDetails || {},
    address: state?.asset?.data?.address || "",
    isLoading: state?.asset?.isLoading?.assetList,
    isFloorView: state.asset.ui.isFloorView,
    isRefresh: state?.asset?.isRefresh || false,
    mapDataIndex: state?.singleAsset?.mapData?.selectedTabIndex || 0,
    isDeviceProfileUpdated: state?.deviceProfile?.shouldUpdate,
    allAssetsListData: state.asset.data.allAssetsListData,
    dynamicMetricValues: state.asset.ui.location
  }));

  const {
    isDeleteOpen,
    isFormOpen,
    selectedAsset,
    notification,
    formdata,
    opType,
    isRefresh,
  } = useSelector((state) => ({
    isDeleteOpen: state.asset.ui.opType === "delete" ? true : false,
    isFormOpen:
      state.asset.ui.opType === "create" ||
      state.asset.ui.opType === "edit" ||
      state.asset.ui.opType === "clone" ||
      state.asset.ui.opType === "selectProfile"
        ? true
        : false,
    selectedAsset: state.asset.ui.selectedAsset,
    notification: state.asset.ui.notification,
    formdata: state.asset.ui.formData,
    opType: state.asset.ui.opType,
    isRefresh: state?.asset?.isRefresh,
  }));
  const firstRender = useRef(true);


  useEffect(() => {
    dispatch(fetchRequest(id));
  }, [dispatch, id, isRefresh]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return; // ⛔️ Skip on first render
    }

    if (!isLoading && asset && Object.keys(asset).length === 0 && id) {
      if (isValidSafeUUIDv4(id)) {
        const cleanURL = DOMPurify.sanitize(id);
        navigate(`/assets/${cleanURL}`, { replace: true });
      }
    }

    if (!isLoading && id) {
      const isAssetEmpty = asset && Object.keys(asset).length === 0;
      const isDeviceEmpty = deviceData && Object.keys(deviceData).length === 0;

      if (isAssetEmpty && isDeviceEmpty) {
        navigate("/assets", { replace: true });
      }
    }
  }, [isLoading, asset, deviceData, id, navigate]);

  useEffect(() => {
    dispatch(fetchDeviceProfilesRequest());
    dispatch(fetchalllocationRequest());
  }, [dispatch, isDeviceProfileUpdated]);

  useEffect(() => {
    if (asset?.deviceid) {
      dispatch(
        fetchRSSIHistoryRequest({
          id: asset?.deviceid,
          startDateTime: isMoreThan7Days(asset?.createdon, asset?.updatedat)
            ? dayjs(asset?.createdon).subtract(7, "day").toISOString()
            : dayjs(asset?.createdon || Date.now()).toISOString(),
          endDateTime: dayjs(asset?.updatedat)?.toISOString(),
          isAsc: true,
        })
      );
    }
    const formData = getSingleAsset([asset], id);
    dispatch(
      updateUI({
        selectedAsset: {
          id,
          name: asset?.assetname,
          opType: null,
          opHeaderText: null,
        },
        opType: null,
        formData,
      })
    );
  }, [asset?.deviceid]);

  useEffect(() => {
    //if (hasPopup == false) return;
    const getData = () => {
      try {
        let value =
          Array.isArray(allAssetsListData) && allAssetsListData.length > 0
            ? {
                deviceId: allAssetsListData[0]?.deviceid,
                endTime: allAssetsListData[0]?.updatedat,
                assetId: allAssetsListData[0]?.assetid,
                startTime: allAssetsListData[0]?.createdon,
                originCoord: [0, 0],
                metrics: dynamicMetricValues?.metrics || {
                  battery: "N/A",
                  temperature: "N/A",
                },
              }
            : null;
        dispatch(fetchLocationAlertsRequest(value));
      } catch (error) {
        console.error("Error fetching location alerts:", error);
      }
    };
    getData();
  }, [allAssetsListData]);

  const handleDeleteProfile = (id) => {
    dispatch(
      updateUI({
        selectedAsset: { id, name: asset?.assetname },
        opType: "delete",
      })
    );
  };

  const handleEditProfile = (id) => {
    const formData = getSingleAsset([asset], id);
    dispatch(
      updateUI({
        selectedAsset: {
          id,
          name: asset?.assetname,
          opType: "edit",
          opHeaderText: "Edit",
        },
        opType: "edit",
        formData,
      })
    );
    dispatch(fetchDeviceTypesRequest());
    dispatch(fetchDeviceNamesRequest());
    dispatch(fetchLocationsRequest());
    dispatch(
      fetchSingleAssetDeviceProfilesRequest(formData?.step2?.deviceType)
    );
  };

  const handleCloneProfile = (id) => {
    const formData = getSingleAsset([asset], id, true);

    dispatch(
      updateUI({
        selectedAsset: {
          id,
          name: asset?.assetname,
          opType: "clone",
          opHeaderText: "Add",
        },
        opType: "clone",
        formData,
      })
    );
    dispatch(fetchDeviceTypesRequest());
    dispatch(fetchDeviceNamesRequest());
    dispatch(fetchLocationsRequest());
    dispatch(
      fetchSingleAssetDeviceProfilesRequest(formData?.step2?.deviceType)
    );
  };

  const items = [
    {
      label: (
        <button onClick={() => handleEditProfile(id)} className="ats-text-btn">
          Edit asset
        </button>
      ),
      key: `${id}-3`,
    },
    {
      label: (
        <button onClick={() => handleCloneProfile(id)} className="ats-text-btn">
          Clone asset
        </button>
      ),
      key: `${id}-5`,
    },
    {
      label: (
        <button
          onClick={() => handleDeleteProfile(id)}
          className="ats-text-btn"
        >
          Delete asset
        </button>
      ),
      key: `${id}-4`,
    },
  ];

  const onExit = () => {
    dispatch(
      updateUI({
        selectedAsset:
          opType === "selectProfile"
            ? {
                opType: selectedAsset?.opType,
                opHeaderText: selectedAsset?.opHeaderText,
              }
            : null,
        opType: opType === "selectProfile" ? selectedAsset?.opType : null,
        formData: {
          selectedStep: 1,
          step1: {
            errors: {
              assetName: false,
            },
            assetName: "",
            description: "",
          },
          step2: {
            errors: {
              deviceType: false,
              deviceId: false,
              deviceProfile: false,
            },
            deviceTypes: [],
            deviceNames: [],
            deviceProfiles: [],
            deviceType: "",
            deviceId: "",
            deviceProfile: "",
          },
          step3: {
            zone: "",
            assetType: "",
            assetModel: "",
            assetSerialNumber: "",
            assetOwner: "",
          },
        },
      })
    );
  };

  return (
    <div className="main-container">
      {notification.isActive &&
        (notification?.message?.toLowerCase() === "delete" ||
          notification?.message?.toLowerCase() === "create") && (
          <Navigate to="/assets" replace={true} />
        )}
      {notification.isActive &&
        notification?.message?.toLowerCase() !== "delete" &&
        notification?.message?.toLowerCase() !== "create" && (
          <ToastNotification
            type={notification.type}
            message={notification.message}
            description={notification.description}
            duration={1}
            style={notification.style}
          />
        )}
      <div style={{ paddingTop: "24px" }}>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link className="ats-text-link" to="/assets">
              <Body size="small" bold={false}>
                Assets
              </Body>
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              className="ats-text-link"
              to={`/assets/${DOMPurify.sanitize(id)}`}
            >
              <Body size="small" bold={true}>
                Asset details
              </Body>
            </Link>
          </BreadcrumbItem>
        </Breadcrumbs>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        {isLoading && <Spin size="small" />}
        {!isLoading && asset?.assetname && (
          <Title size="large" color="#000000" bold={false}>
            {asset?.assetname}
          </Title>
        )}

        <Dropdown
          key={`dropdown-${id}`}
          menu={{
            items,
          }}
          trigger={["click"]}
          overlayClassName="shipment-dropdown-overlay"
        >
          <Button size="large" disabled={false} use="secondary">
            Action
          </Button>
        </Dropdown>
      </div>

      <div className="ats-view-assets">
        <Tabs
          orientation="horizontal"
          indicatorPosition="bottom"
          selectedIndex={mapDataIndex}
        >
          <Tab
            label={isFloorView ? "Floor View" : "Map view"}
            onClick={() => {
              dispatch(mapDataTabIndex(0));
            }}
          >
            <AssetMapView
              deviceData={deviceData}
              address={address}
              deviceid={asset?.deviceid}
              assetid={asset?.assetid}
            />
          </Tab>
          <Tab
            label="Alerts"
            onClick={() => {
              dispatch(mapDataTabIndex(1));
            }}
          >
            <AssetAlertView assetid={asset?.assetid} />
          </Tab>
          <Tab
            label="Asset data"
            onClick={() => {
              dispatch(mapDataTabIndex(2));
            }}
          >
            <AssetDataView
              deviceid={asset?.deviceid}
              startDate={asset?.createdon}
              endDate={asset?.updatedat}
            />
          </Tab>
        </Tabs>
        <CreateDeviceProfile />
        <FormAsset
          opHeaderText={selectedAsset?.opHeaderText}
          formData={formdata}
          open={isFormOpen}
          onConfirm={() => {}}
          onExit={() => {
            onExit();
          }}
        />
        <DeleteAssetModal
          message={selectedAsset?.name}
          onConfirm={() => {
            dispatch(deleteRequest());
          }}
          onExit={() => {
            onExit();
          }}
          open={isDeleteOpen}
        />
      </div>
    </div>
  );
}

export default ViewAsset;
